module.exports = __webpack_public_path__ + "static/DSC_3-82c072577d01064c6f5c24cf4ef3577d.jpg";